import { LocalStorage, SessionStorage } from "./storage";

export const Storage = {
	LocalStorage,
	SessionStorage
};
